import React from 'react';
import PropTypes from 'prop-types';
import RecommendationsProductList from '../RecommendationsProductList';
import Outfits from '../../Outfits';

const WearItWithCarousel = ({
    messages,
    recommendations,
    intelistyleWiw,
    useOutfitView,
    reducedMode,
    colourPartNumber,
    tracking,
    variation,
    images,
    isCarouselVisible,
    addToCart,
    isWithAddToBag,
    className,
    useDefaultCarouselIndex,
    withQuickAdd,
}) => {
    if (!recommendations?.WIW_ProductRec && intelistyleWiw.length === 0) return null;

    if (useOutfitView && !reducedMode) {
        return (
            <Outfits
                messages={messages}
                heading={messages.wearItWith.heading}
                colourPartNumber={colourPartNumber}
                recommendations={recommendations.WIW_ProductRec}
                intelistyleRecommendations={intelistyleWiw}
                onClick={tracking.wiw}
                tracking={tracking}
                type={'wiw'}
                variation={variation}
                images={images}
            />
        );
    }

    return (
        <RecommendationsProductList
            messages={messages}
            heading={messages.wearItWith.heading}
            colourPartNumber={colourPartNumber}
            recommendations={recommendations.WIW_ProductRec?.[0]?.products || intelistyleWiw}
            onClick={tracking.wiw}
            isCarouselVisible={isCarouselVisible}
            type={'wiw'}
            tracking={tracking}
            addToCart={addToCart}
            isWithAddToBag={isWithAddToBag}
            className={className}
            useDefaultCarouselIndex={useDefaultCarouselIndex}
            withQuickAdd={withQuickAdd}
            variation={variation}
            reducedMode={reducedMode}
        />
    );
};

export default WearItWithCarousel;

WearItWithCarousel.propTypes = {
    messages: PropTypes.shape({
        wearItWith: PropTypes.shape({
            heading: PropTypes.func.isRequired,
        }).isRequired,
        youMayAlsoLike: PropTypes.shape({
            heading: PropTypes.func.isRequired,
        }).isRequired,
    }),
    recommendations: PropTypes.object,
    intelistyleWiw: PropTypes.array,
    useOutfitView: PropTypes.bool,
    reducedMode: PropTypes.bool,
    colourPartNumber: PropTypes.string.isRequired,
    tracking: PropTypes.shape({
        wiw: PropTypes.func,
    }),
    variation: PropTypes.string,
    isCarouselVisible: PropTypes.bool,
    addToCart: PropTypes.func,
    isWithAddToBag: PropTypes.bool,
    className: PropTypes.string,
    useDefaultCarouselIndex: PropTypes.bool,
    withQuickAdd: PropTypes.bool,
    images: PropTypes.array,
};
